import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home/home'
import login from '@/components/auth/Loginhome'
import loginAD from '@/components/auth/loginwithAD'
import navbar from '@/components/publicData/navbar'
import about from '@/components/about'
import bar from '@/components/bar'
import contact from '@/components/contact'
import PrivacyPolicy from '@/components/home/footer/PrivacyPolicy'
import TermConditionofUse from '@/components/home/footer/TermConditionofUse'
import CookiesPolicy from '@/components/home/footer/CookiesPolicy'
import policy from '@/components/auth/policy'
import navbarAdmin from '@/components/admin/navbar'
import management from '@/components/admin/managementConsole'
import userprofile from '@/components/auth/userprofile'
import mgmtPermission from '@/components/admin/managementMenu/mgmtPermission'
import metadata from '@/components/admin/metadata/metadata'
// import ConsentAgreement from '@/components/admin/ConsentAgreement'
import monitoring from '@/components/admin/monitoring'
import permission from '@/components/admin/permission'
import SystemReport from '@/components/admin/SystemReport/SystemReport'
import viewdashboard from '@/components/publicData/dashboard/viewdashboard'
import api from '@/components/publicData/dashboard/api'
import favorite from '@/components/home/favorite'
import AddFile from "@/components/admin/metadata/AddFile";
import workbench from "@/components/admin/metadata/workbench";
import organization from "@/components/admin/Organization/Organization";
import Category from "@/components/admin/Category/Category";
import Cookienbtc from '@/components/auth/cookienbtc.vue';
// import Callback from '@/components/auth/Callback.vue';
import SecuredPage from "@/components/auth/SecuredPage.vue";
// import OpenIdLogin from "../src/components/auth/SamlLogin.vue";
// import saml from '@/components/auth/testsaml.vue';
import OpenIdCallback from '@/components/auth/OpenIdCallback.vue';
import { Encode, Decode } from "@/services";
import loginlocal from '@/components/auth/Loginlocal'
import store from '@/stores/store.js'
import apidocs from '@/components/publicData/apiswagger';



Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/loginOpenID',
    //   name: 'OpenIdCallback',
    //   component: OpenIdCallback
    // },
    {
      path: '/login/local', name: 'name', component: loginlocal, meta: { logincheck: true },
      children: [
        { path: '/user/:id', component: loginlocal },
        { path: '/verify/:id', component: loginlocal },
        { path: '/unlock/:id', component: loginlocal },
        { path: '/resetpassword/:id', component: loginlocal },
        { path: '/secured', component: SecuredPage },
      ]
    },
    {
      path: '/login', name: 'name', component: login, meta: { logincheck: true },
      children: [
        { path: '/user/:id', component: login },
        { path: '/verify/:id', component: login },
        { path: '/unlock/:id', component: login },
        { path: '/resetpassword/:id', component: login },
        { path: '/secured', component: SecuredPage },
        // {
        //   path: '/openid-login',
        //   name: 'openidLogin',
        //   component: OpenIdLogin
        // },
      ]
    },
    {
      path: '/loginAD', component: loginAD, meta: { logincheck: true },
    },
    {
      path: '/',
      component: bar,
      meta: { requiresAuth: true },
      children: [
        // { path: '/home', component: home},
        { path: '/', component: home },
        { path: '/opendata/:id', component: navbar },
        { path: '/home/about', component: about },
        { path: '/home/favorite', component: favorite },
        { path: '/home/contact', component: contact },
        { path: '/home/PrivacyPolicy', component: PrivacyPolicy },
        { path: '/home/TermConditionofUse', component: TermConditionofUse },
        { path: '/home/CookiesPolicy', component: CookiesPolicy },
        { path: '/admin/navbarAdmin', component: navbarAdmin },
        { path: '/admin/management', component: management,  meta: { requiresAuth: true, menuName: 'Management' } },
        { path: '/admin/UserAccessManagement', component: navbarAdmin, meta: { requiresAuth: true, menuName: 'User Access Management' } },
        { path: '/admin/DatasetConfiguration', component: navbarAdmin, meta: { requiresAuth: true, menuName: 'Dataset Configuration' }},
        // { path: '/admin/TaskMonitoring', component: navbarAdmin },
        { path: '/admin/UserManagement', component: navbarAdmin, meta: { requiresAuth: true, menuName: 'User Management' } },
        { path: '/admin/PermissionManagement', component: navbarAdmin, meta: { requiresAuth: true, menuName: 'Permission Management' } },
        // { path: '/admin/ConsentAgreement', component: navbarAdmin, meta: { requiresAuth: true, menuName: 'Consent Agreement' } },
        { path: '/admin/ReportsManagement', component: navbarAdmin, meta: { requiresAuth: true, menuName: 'Reports Management' } },
        { path: '/admin/GroupReportsManagement', component: navbarAdmin, meta: { requiresAuth: true, menuName: 'Group Reports Management' } },
        { path: '/admin/ReportPermissionMonitor', component: navbarAdmin,  meta: { requiresAuth: true, menuName: 'Report Permission Monitor' } }, 
        { path: '/admin/addfile', component: navbarAdmin, meta: { requiresAuth: true, menuName: 'Add File' }},
        // { path: '/admin/WorkBench', component: navbarAdmin,  meta: { requiresAuth: true, menuName: 'Work Bench' } },
        // { path: '/admin/DataSource', component: navbarAdmin, meta: { requiresAuth: true, menuName: 'Data Source' } },
        { path: '/admin/GroupUserManagement', component: navbarAdmin, meta: { requiresAuth: true, menuName: 'Group User Management' } },
        //{ path: '/admin/DatasetManagement', component: navbarAdmin, meta: { requiresAuth: true, menuName: 'Dataset Management' } },
        { path: '/admin/ReportConfiguration', component: navbarAdmin, meta: { requiresAuth: true, menuName: 'Report Configuration' } },      
        { path: '/view/dashboard/:id', component: viewdashboard },
        { path: '/view/api/:id', component: api },
        { path: '/userprofile/:id', component: userprofile },
        { path: '/workbench/:id', component: workbench },
        { path: '/admin/Organization', component: navbarAdmin, meta: { requiresAuth: true, menuName: 'Organization' }  },
        { path: '/admin/Category', component: navbarAdmin, meta: { requiresAuth: true, menuName: 'Category' } },
        // { path: '/docs', name: 'ApiDocs', component: apidocs },
      ]
    },
    { path: '/policy', component: policy },
    // { path: '/Cookie-list.aspx', component: Cookienbtc },
    // { path: '/callback', component: Callback },
    // { path: '/loginOpenID', name: 'OpenIdCallback', components: OpenIdCallback},
    { path: '*', redirect: '/' }
  ]
})
/*
router.beforeEach((to, from, next) => {
  if (to.matched.some((x) => x.meta.requiresAuth)) {
    if (!window.$cookies.isKey('information')) {
      //next({ path: '/login' })
      window.location.href = 'https://mypage.tint.or.th/'
      return
    } else {
      Vue.prototype.$isLoading = true;
      next()
    }
    return
  }
  next()
})*/

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((x) => x.meta.requiresAuth)
  const SSO_FLAG_KEY = 'sso_in_progress'
  const hasInfoCookie = window.$cookies.isKey('information')

  if (!requiresAuth) {
    // หน้าไหนไม่ต้องล็อกอิน ปล่อยผ่าน
    return next()
  }

  // ---- มี cookie แล้ว = login แล้ว ----
  if (hasInfoCookie) {
    // กลับมาจาก SSO แล้ว เคลียร์ flag ทิ้ง
    window.localStorage.removeItem(SSO_FLAG_KEY)
    Vue.prototype.$isLoading = true
    return next()
  }

  // ---- ยังไม่มี cookie = ยังไม่ได้ login ----
  const ssoInProgress = window.localStorage.getItem(SSO_FLAG_KEY)

  if (!ssoInProgress) {
    // ยังไม่เคยเด้งไป SSO → mark ว่ากำลังจะไป แล้วเด้งออกไป SSO รอบแรก
    window.localStorage.setItem(SSO_FLAG_KEY, '1')
    window.location.href = 'https://mypage.tint.or.th/'
    return
  }

  // มาถึงตรงนี้ = เคยเด้งไป SSO แล้ว แต่ยังไม่มี cookie (กำลังอยู่ระหว่าง SSO / redirect)
  // กันไม่ให้มันวิ่ง redirect ซ้ำ ๆ / ยิง request รัว ๆ
  return next(false)
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((x) => x.meta.logincheck)) {
  
    if (to.path === '/login' && to.query.saml_login) {
      // กรณี callback จาก SAML → ปล่อยให้ Loginhome.vue จัดการเอง
      next();
      return;
    }
    
    var param = window.location.href
    var name = param.substring(param.lastIndexOf("/") + 1, param.length);
    if (window.$cookies.isKey('information') && ( name === 'login' || name === 'loginAD')) {
      Vue.prototype.$isLoading = true;
      next({ path: '/' })
    } else {
      next()
    }
    return
  }
  next()
})

router.beforeEach(async (to, from, next) => {
  console.log("Routing to:", to.path); // Log จุดเริ่มต้น

  if (to.matched.some(record => record.path.startsWith('/admin'))) {
    if (!window.$cookies.isKey('information')) {
      console.log('No information cookie found, redirecting to login.');
      next({ path: '/login/local' });
      return;
    }

    const user = JSON.parse(Decode.decode(Vue.prototype.$cookies.get('information')));
    console.log('User info:', user);

    if (user.isAdmin === "false") {
      console.log('User is not admin, redirecting to home.');
      next({ path: '/' });
      return;
    }

    // รอจนกว่าการ fetch ข้อมูลจะเสร็จสิ้น
    if (store.getters.menuPermissions.length === 0 || store.getters.getMenuCategory.length === 0) {
      console.log('Fetching menu names and permissions');
      await store.dispatch('getMenuName');
      await store.dispatch('getMenuPermission');
    }

    const permissions = store.getters.menuPermissions.map(item => item.menu_name_id);
    const menuCategory = store.getters.getMenuCategory.find(item => item.menu_name === to.meta.menuName);

// ===== injected robust permission check =====
(function () {
  function norm(s) {
    if (s === undefined || s === null) s = '';
    s = String(s);
    return s.replace(/^\s+|\s+$/g, '').toLowerCase().replace(/\s+/g, ' ');
  }

  var categories = Array.isArray(store.getters.getMenuCategory)
    ? store.getters.getMenuCategory
    : [];

  var permsSrc = store.getters.menuPermissions || [];
  var perms = permsSrc.map(function (i) { return i.menu_name_id; });

  var menuCategory = null;

  // 1) จับจาก meta.menuName แบบยืดหยุ่น
  if (to.meta && to.meta.menuName) {
    var want = norm(to.meta.menuName);
    for (var i = 0; i < categories.length && !menuCategory; i++) {
      if (norm(categories[i].menu_name) === want) menuCategory = categories[i];
    }
    if (!menuCategory) {
      for (var j = 0; j < categories.length && !menuCategory; j++) {
        if (norm(categories[j].menu_name).indexOf(want) !== -1) menuCategory = categories[j];
      }
    }
  }

  // 2) Fallback: match ด้วย path/route/url
  if (!menuCategory) {
    for (var k = 0; k < categories.length && !menuCategory; k++) {
      var it = categories[k];
      if (!it) continue;
      if ((it.route && it.route === to.path) ||
          (it.path  && it.path  === to.path) ||
          (it.url   && it.url   === to.path)) {
        menuCategory = it;
      }
    }
  }

  // 3) aliases เผื่อสะกดต่างกัน
  if (!menuCategory && to.meta && to.meta.menuName) {
    var aliases = {
      'Dataset Configuration': ['Dataset Configuration','Dataset Config','DatasetConfiguration'],
      'Group Dataset Management': ['Group Dataset Management','Group Dataset','GroupDatasetManagement'],
      'User Management': ['User Management','UserManagement']
    };
    var aliasHit = null;
    var wantAlias = norm(to.meta.menuName);
    for (var key in aliases) {
      if (!aliases.hasOwnProperty(key)) continue;
      var arr = aliases[key];
      for (var a = 0; a < arr.length; a++) {
        if (norm(arr[a]) === wantAlias) { aliasHit = key; break; }
      }
      if (aliasHit) break;
    }
    if (aliasHit) {
      for (var m = 0; m < categories.length && !menuCategory; m++) {
        if (norm(categories[m].menu_name) === norm(aliasHit)) menuCategory = categories[m];
      }
    }
  }

  // 4) สรุปสิทธิ์ (เฉพาะหน้าที่กำหนด meta.menuName)
  if (to.meta && to.meta.menuName) {
    if (!menuCategory) {
      try {
        /* eslint-disable no-console */
        console.warn('[perm] menu not found for:', to.meta.menuName,
          'available=', categories.map(function (x) { return x.menu_name; }));
        /* eslint-enable no-console */
      } catch (e) {}
      next('/'); return; // กันพลาด
    }
    var has = false;
    for (var p = 0; p < perms.length; p++) {
      if (perms[p] === menuCategory.menu_name_id) { has = true; break; }
    }
    if (!has) {
      try { console.warn('[perm] no permission for:', to.meta.menuName,
        'id=', menuCategory.menu_name_id, 'perms=', perms); } catch (e) {}
      next('/'); return; // ไม่มีสิทธิ์
    }
  }
})();
// ===== end injected =====


    console.log('Permissions:', permissions);
    console.log('Menu Category:', menuCategory);

    if (menuCategory && permissions.includes(menuCategory.menu_name_id)) {
      console.log('User has permission, proceeding.');
      next();
    } else {
      console.log('User does not have permission, redirecting to home.');
      next({ path: '/' });
    }
  } else {
    console.log('No admin route, proceeding.');
    next();
  }
});

router.beforeEach((to, from, next) => {
  const isMobile = window.innerWidth <= 600; // เช็คว่าเป็นอุปกรณ์มือถือหรือไม่
  const isAdminRoute = to.path.startsWith('/admin'); // เช็คว่าเป็นเส้นทางของแอดมินหรือไม่

  if (isMobile && isAdminRoute) {
    // ถ้าเป็นมือถือและพยายามเข้าถึงเส้นทางของแอดมิน
    alert('เมนูผู้ดูแลระบบไม่สามารถเข้าใช้งานผ่าน mobile ได้');
    next('/home'); // เปลี่ยนเส้นทางกลับไปหน้า home หรือหน้าอื่น ๆ ตามที่คุณต้องการ
  } else {
    next(); // ดำเนินการต่อถ้าเงื่อนไขไม่ตรง
  }
});


//login token check
/*
router.beforeEach(async (to, from, next) => {
  // Allow routes that don’t require auth
  if (!to.matched.some(record => record.meta.requiresAuth)) return next();

  const token = Vue.prototype.$cookies.get('access_token');

  return next();
  
  // If there's no token, block access
  if (!token) {
    alert("กรุณาเข้าสู่ระบบ");
    return next('/login');
  }

  try {
    const res = await fetch(process.env.VUE_APP_API_BACKEND + '/verify-token', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token })
    });

    const data = await res.json();

    if (data.status !== 'valid') {
      // Clean up cookies and localStorage
      Vue.prototype.$cookies.remove('access_token');
      Vue.prototype.$cookies.remove('information');
      Vue.prototype.$cookies.remove('usertype');
      localStorage.clear();
      alert("เซสชันหมดอายุหรือไม่ถูกต้อง กรุณาเข้าสู่ระบบใหม่");
      return next('/login');
    }

    // ✅ Token valid and session_id confirmed
    return next();

  } catch (err) {
    console.error('JWT verification error:', err);
    alert("เกิดข้อผิดพลาดในการตรวจสอบเซสชัน");
    return next('/login');
  }
});
*/

router.afterEach(() => {
  Vue.prototype.$isLoading = false;
});

export default router;
